import { provideRouteChangeHandler } from '@frontend-site/shared/router-store';
import { ProjectDetailsCleanerService } from './project-details-cleaner.service';

export const projectDetailsCleanerServiceProvider = provideRouteChangeHandler(ProjectDetailsCleanerService);
